import CountryFlag from "react-country-flag";
import { countryName } from "./labels";

interface CountryColumnCellProps {
  country: string;
}

export default function CountryColumnCell({ country }: CountryColumnCellProps) {
  const name = countryName(country);
  return (
    <div className="flex flex-row items-center gap-1.5 text-[13px] pr-2">
      <CountryFlag
        svg
        className="rounded-xs min-w-4.5 h-1.75"
        countryCode={country}
        title={name || country}
      />
      <span className="truncate leading-5">{name || "-"}</span>
    </div>
  );
}
